/* HOSS — Theme JavaScript */

document.addEventListener('DOMContentLoaded', () => {
  initGallery();
  initQuantityButtons();
  initCartDrawer();
});

function initGallery() {
  const gallery = document.querySelector('[data-pdp-gallery]');
  if (!gallery) return;

  const slides = Array.from(gallery.querySelectorAll('.pdp-gallery__slide'));
  const hint = gallery.querySelector('[data-scroll-hint]');
  if (!slides.length) return;

  slides.forEach(slide => {
    const clone = slide.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    clone.dataset.galleryClone = 'true';
    gallery.appendChild(clone);
  });

  let segmentWidth = gallery.scrollWidth / 2;
  let hideHintTimer;
  let lastFrame;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const scrollSpeed = 22;
  let isPaused = reducedMotion.matches;

  const refreshSegmentWidth = () => {
    segmentWidth = gallery.scrollWidth / 2;
  };

  const wrapScroll = () => {
    if (!segmentWidth) return;
    if (gallery.scrollLeft >= segmentWidth) {
      gallery.scrollLeft -= segmentWidth;
    }
  };

  gallery.addEventListener('scroll', () => {
    wrapScroll();

    if (hint && gallery.scrollLeft > 50) {
      hint.style.opacity = '0';
      clearTimeout(hideHintTimer);
      hideHintTimer = setTimeout(() => { hint.style.display = 'none'; }, 300);
    }
  }, { passive: true });

  if (hint) {
    hint.style.transition = 'opacity 0.3s ease';
  }

  gallery.addEventListener('mouseenter', () => { isPaused = true; });
  gallery.addEventListener('mouseleave', () => { isPaused = reducedMotion.matches; });
  gallery.addEventListener('focusin', () => { isPaused = true; });
  gallery.addEventListener('focusout', () => { isPaused = reducedMotion.matches; });
  gallery.addEventListener('pointerdown', () => { isPaused = true; });
  gallery.addEventListener('pointerup', () => { isPaused = reducedMotion.matches; });
  gallery.addEventListener('pointercancel', () => { isPaused = reducedMotion.matches; });
  window.addEventListener('resize', refreshSegmentWidth);
  reducedMotion.addEventListener('change', event => {
    isPaused = event.matches;
  });

  function animateGallery(timestamp) {
    if (lastFrame === undefined) lastFrame = timestamp;
    const delta = timestamp - lastFrame;
    lastFrame = timestamp;

    if (!isPaused && document.visibilityState !== 'hidden') {
      gallery.scrollLeft += (scrollSpeed * delta) / 1000;
      wrapScroll();
    }

    requestAnimationFrame(animateGallery);
  }

  requestAnimationFrame(animateGallery);
}

function initCartDrawer() {
  const drawer = document.getElementById('cart-drawer');
  if (!drawer) return;

  // Open
  document.querySelectorAll('[data-cart-open]').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cart-open');
    });
  });

  // Close
  document.querySelectorAll('[data-cart-close]').forEach(el => {
    el.addEventListener('click', () => {
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cart-open');
    });
  });

  // Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') {
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cart-open');
    }
  });

  // Quantity buttons in cart drawer
  drawer.querySelectorAll('[data-cart-qty-minus]').forEach(btn => {
    btn.addEventListener('click', () => {
      const line = parseInt(btn.dataset.line);
      const item = drawer.querySelectorAll('.cart-drawer__item')[line - 1];
      const display = item.querySelector('.cart-drawer__qty-value');
      const current = parseInt(display.textContent);
      if (current <= 1) return;
      updateCartLine(line, current - 1);
    });
  });

  drawer.querySelectorAll('[data-cart-qty-plus]').forEach(btn => {
    btn.addEventListener('click', () => {
      const line = parseInt(btn.dataset.line);
      const item = drawer.querySelectorAll('.cart-drawer__item')[line - 1];
      const display = item.querySelector('.cart-drawer__qty-value');
      const current = parseInt(display.textContent);
      updateCartLine(line, current + 1);
    });
  });

  // Remove buttons
  drawer.querySelectorAll('.cart-drawer__item-remove').forEach((btn, i) => {
    btn.addEventListener('click', () => {
      updateCartLine(i + 1, 0);
    });
  });
}

function updateCartLine(line, quantity) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ line, quantity })
  })
  .then(r => r.json())
  .then(() => { window.location.reload(); })
  .catch(console.error);
}

function initQuantityButtons() {
  document.querySelectorAll('[data-qty-minus]').forEach(btn => {
    btn.addEventListener('click', () => {
      const wrapper = btn.closest('.pdp-sticky-bar__qty');
      const input = wrapper.querySelector('[data-qty-input]');
      const display = wrapper.querySelector('[data-qty-value]');
      const val = Math.max(1, parseInt(input.value) - 1);
      input.value = val;
      display.textContent = val;
    });
  });

  document.querySelectorAll('[data-qty-plus]').forEach(btn => {
    btn.addEventListener('click', () => {
      const wrapper = btn.closest('.pdp-sticky-bar__qty');
      const input = wrapper.querySelector('[data-qty-input]');
      const display = wrapper.querySelector('[data-qty-value]');
      const val = parseInt(input.value) + 1;
      input.value = val;
      display.textContent = val;
    });
  });
}
